import { render, staticRenderFns } from "./VModalRemarkRejectionSend.vue?vue&type=template&id=335582b1&"
import script from "./VModalRemarkRejectionSend.vue?vue&type=script&lang=ts&"
export * from "./VModalRemarkRejectionSend.vue?vue&type=script&lang=ts&"
import style0 from "./VModalRemarkRejectionSend.vue?vue&type=style&index=0&id=335582b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports